import React from 'react'

function MailIcon({ color = "currentColor", size = 26, ...rest }) {
    return (
        <svg {...rest} width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.6667 4.66669L8.67271 8.48469C8.4693 8.60283 8.23827 8.66506 8.00304 8.66506C7.76782 8.66506 7.53678 8.60283 7.33337 8.48469L1.33337 4.66669" stroke={color} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.3334 2.66669H2.66671C1.93033 2.66669 1.33337 3.26364 1.33337 4.00002V12C1.33337 12.7364 1.93033 13.3334 2.66671 13.3334H13.3334C14.0698 13.3334 14.6667 12.7364 14.6667 12V4.00002C14.6667 3.26364 14.0698 2.66669 13.3334 2.66669Z" stroke={color} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export default MailIcon